import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TranslateApiService {
  private cache = new Map<string, string>();
  // Public LibreTranslate endpoint (no API key). Replace with your provider if needed.
  private endpoint = 'https://libretranslate.de/translate';

  constructor(private http: HttpClient) { }

  translate(text: string, target = 'en'): Observable<string> {
    if (!text) {
      return of(text);
    }

    const key = `${target}:${text}`;
    if (this.cache.has(key)) {
      return of(this.cache.get(key) as string);
    }

    const body = {
      q: text,
      source: 'auto',
      target,
      format: 'text'
    };

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post<any>(this.endpoint, body, { headers }).pipe(
      map(res => {
        const translated = res && (res.translatedText || res.translated_text) ? (res.translatedText || res.translated_text) : text;
        this.cache.set(key, translated);
        return translated;
      }),
      catchError(() => of(text))
    );
  }
}
